module.exports = __webpack_public_path__ + "img/collected_done.24d78cb6.svg";